import React from 'react';
import { LoadingSpinnerIconSpan } from '../../../../LoadingSpinnerIconSpan';

export function SchedulingIntegrationFetchState() {
  return (
    <div className='d-flex fs-6 align-items-center'>
      <LoadingSpinnerIconSpan
        iconClassName='text-blue me-2'
        iconSize='lg'
        text={'Checking scheduling options ...'}
      />
    </div>
  );
}
